(function () {
  'use strict';

  // ─── Filter drawer (mobile/tablet) ──────────────────────────────────────────

  const sidebar   = document.getElementById('clv2-sidebar');
  const filterBtn = document.getElementById('clv2-filter-btn');
  const closeBtn  = document.getElementById('clv2-sidebar-close');
  const backdrop  = document.getElementById('clv2-backdrop');

  function openDrawer() {
    if (!sidebar) return;
    sidebar.classList.add('clv2__sidebar--open');
    backdrop.classList.add('clv2__backdrop--visible');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!sidebar) return;
    sidebar.classList.remove('clv2__sidebar--open');
    backdrop.classList.remove('clv2__backdrop--visible');
    document.body.style.overflow = '';
  }

  filterBtn  && filterBtn.addEventListener('click', openDrawer);
  closeBtn   && closeBtn.addEventListener('click', closeDrawer);
  backdrop   && backdrop.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeDrawer();
  });

  // ─── Sort — auto-submit on change ───────────────────────────────────────────

  const sortSelect = document.getElementById('clv2-sort');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const form = document.getElementById('clv2-filter-form');
      if (form) form.submit();
    });
  }

  // ─── Filter checkboxes — auto-submit on change (desktop) ────────────────────
  // On desktop the sidebar is always visible so we submit immediately.
  // On mobile we wait for the Apply button.

  function isDesktop() {
    return window.innerWidth >= 990;
  }

  const filterForm = document.getElementById('clv2-filter-form');
  if (filterForm) {
    filterForm.querySelectorAll('.clv2__filter-checkbox').forEach(checkbox => {
      checkbox.addEventListener('change', () => {
        if (isDesktop()) filterForm.submit();
      });
    });

    // Price range — submit on blur
    filterForm.querySelectorAll('.clv2__price-input').forEach(input => {
      input.addEventListener('change', () => {
        if (isDesktop()) filterForm.submit();
      });
    });
  }

})();
